<div class="error-wrapper">
  <h1 class="error-title">{{errorTitle}}</h1>
  <p *ngIf="error" class="error-message">{{error}}</p>
</div>
